module.exports = __webpack_public_path__ + "img/Marshall.91741f52.jpg";